import React, { useContext } from "react";
import {
  Container,
  Divider,
} from "semantic-ui-react";
import { store } from "../store";

const Footer: React.FunctionComponent = () => {
    const globalState = useContext(store);
    const { dispatch } = globalState;

    return (

        <Container textAlign="center"
            style={{ backgroundColor: globalState.state.appState.isDarkTheme ? "#282c34" : "whitesmoke", padding: "0em 0em 1em 0em" }}>
              <Divider section />
              <span
                style={{ color: globalState.state.appState.isDarkTheme ? "whitesmoke" : "black" }}>&copy; {(new Date()).getFullYear()} - NJCRIB</span>
            </Container>

    );
};

export default Footer;
